import { useQuery } from "@tanstack/react-query";
import { parseSingleParticipant } from "./helpers";

async function getParticipantById({
  callApiWithWorker,
  participantId,
  lang,
  signal,
}) {
  const url =
    `/registry/participants/${encodeURIComponent(participantId)}` +
    `?lang=${encodeURIComponent(lang)}`;

  const res = await callApiWithWorker(url, {
    method: "GET",
    connector: "springConnector",
    signal,
  });

  return parseSingleParticipant(res);
}

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string | undefined | null} deps.participantId
 * @param {string | undefined | null} deps.lang
 * @param {boolean | undefined} deps.enabled
 */
export function useGetParticipantById({
  callApiWithWorker,
  participantId,
  lang,
  enabled = true,
}) {
  return useQuery({
    queryKey: ["participants", "byId", participantId, lang],
    enabled: enabled && !!participantId,
    queryFn: ({ signal } = {}) =>
      getParticipantById({ callApiWithWorker, participantId, lang, signal }),
    staleTime: 30_000,
  });
}
